import React from 'react';

const Layer2 = () => {
  return (
    <svg
      preserveAspectRatio='xMinYMin meet' // You can adjust this as needed
      width='510'
      height='416'
      viewBox='0 0 510 416'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className=' absolute left-[-1px] bottom-[-7px] z-30'
      style={{ height: '416px', width: '510px' }}
    >
      <path
        d='M509.258 370.594C509.258 395.17 489.334 415.094 464.758 415.094L45.0158 415.094C20.4391 415.094 0.51584 395.17 0.515843 370.594L0.515872 34.8087C34.8713 22.5513 62.3617 16.0031 89.3626 15.0361C116.447 14.0661 143.072 18.7109 175.673 28.8858C187.514 32.5817 200.33 31.6605 211.633 26.5699C304.369 -15.1966 378.044 -1.15535 509.258 34.8377L509.258 370.594Z'
        fill='#083E60'
        stroke='white'
      />
    </svg>
  );
};

export default Layer2;
